// DateTimePicker shim for web compatibility
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

interface DateTimePickerProps {
  value?: Date;
  mode?: 'date' | 'time' | 'datetime';
  display?: 'default' | 'spinner' | 'clock' | 'calendar';
  onChange?: (event: any, selectedDate?: Date) => void;
  minimumDate?: Date;
  maximumDate?: Date;
  [key: string]: any;
}

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  value,
  mode = 'date',
  onChange,
  ...props
}) => {
  const handlePress = () => {
    // On web, use native HTML5 date/time inputs
    if (typeof (globalThis as any).window !== 'undefined' && (globalThis as any).window.document) {
      const input = (globalThis as any).window.document.createElement('input');
      input.type = mode === 'date' ? 'date' : mode === 'time' ? 'time' : 'datetime-local';
      if (value) {
        const dateStr = value.toISOString().slice(0, mode === 'date' ? 10 : mode === 'time' ? 16 : 19);
        input.value = dateStr;
      }
      input.onchange = (e: any) => {
        if (onChange && e.target.value) {
          const newDate = new Date(e.target.value);
          onChange({ type: 'set', nativeEvent: { timestamp: newDate.getTime() } }, newDate);
        }
      };
      input.click();
    }
  };

  return (
    <TouchableOpacity onPress={handlePress} style={styles.container}>
      <Text style={styles.text}>
        {value ? value.toLocaleString() : `Select ${mode}`}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 12,
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#ddd',
  },
  text: {
    fontSize: 16,
    color: '#333',
  },
});

export default DateTimePicker;

